import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';

const material: any = [
	MatToolbarModule,
	MatSidenavModule,
	MatIconModule,
	MatSlideToggleModule,
	MatButtonModule,
	MatDividerModule,
	MatCardModule,
	MatFormFieldModule,
	MatInputModule,
	MatMenuModule,
	MatSelectModule,
	MatTooltipModule,
	MatSliderModule,
	MatTableModule,
	MatProgressSpinnerModule,
	MatListModule,
	MatCheckboxModule
];


@NgModule({
	providers: [
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
				floatLabel: 'always'
			}
		}
	],
	exports: [material],
	imports: [material]
})
export class MaterialModule { }
